import { APP_PERMISSIONS } from '@exam-center/permission';
import { AddIcon, Button, type ButtonProps } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { WithPermission } from '@shared/permissions';

import { ExamCenterCreationModal } from '../exam-center-creation-modal';

type ExamCenterCreationButtonProps = Pick<ButtonProps, 'variant'>;

export default function ExamCenterCreationButton(props: Readonly<ExamCenterCreationButtonProps>) {
  const { variant = 'contained' } = props;
  const [isOpen, examCenterCreationModalHandlers] = useDisclosure(false);
  const { open: openExamCenterCreationModal, close: closeExamCenterCreationModal } =
    examCenterCreationModalHandlers;

  return (
    <WithPermission
      requiredPermission={APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_CENTER.CREATE}
    >
      <Button
        size='large'
        startIcon={<AddIcon />}
        variant={variant}
        onClick={openExamCenterCreationModal}
      >
        เพิ่มศูนย์ทดสอบ
      </Button>
      <ExamCenterCreationModal open={isOpen} onClose={closeExamCenterCreationModal} />
    </WithPermission>
  );
}
